
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/products",
      function () {
        return require("private-next-pages/[lang]/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/products"])
      });
    }
  